import { FieldDescription } from './FieldDescription';
import { cn } from '~/shared/components/utils';
import { fieldLabelStyles } from './util';

export function FormLabelNoControl({ label, description, className }: { label?: string; description?: string; className?: string }) {
	return (
		<div>
			{label && (
				<div className={cn(fieldLabelStyles(), 'mb-2', className)}>
					<span dangerouslySetInnerHTML={{ __html: label }} />
				</div>
			)}

			{description && <FieldDescription>{description}</FieldDescription>}
		</div>
	);
}
